export enum CallStatusType
{
    Ringing = 0,
    Active = 1,
    Finished = 2,
    FinishedLostRace = 3,
    FinishedNotAnswered = 4
}